// extracted by mini-css-extract-plugin
export var button = "_bx-0";
export var icon = "_bx-1";